import $x from '@/utils/$x';

/**
 * 教练薪资结算单-分页查询
 * @param {*} params
 * @returns
 */
export async function coachSalaryStatementPageList(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/coachSalaryStatementPageList',
    params,
  );
}

/**
 * 教练薪资结算单-新建对账单
 * @param {*} params
 * @returns
 */
export async function newCoachSalaryStatement(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/newCoachSalaryStatement',
    params,
  );
}

/**
 * 教练薪资结算单-提交对账单
 * @param {*} params
 * @returns
 */
export async function submitCoachSalaryStatement(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/submitCoachSalaryStatement',
    params,
  );
}

/**
 * 教练薪资结算单-查看对账单
 * @param {*} params
 * @returns
 */
export async function getCoachSalaryStatement(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/getCoachSalaryStatement',
    params,
  );
}

/**
 * 教练薪资结算单-删除对账单
 * @param {*} params
 * @returns
 */
export async function deleteCoachSalaryStatement(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/deleteCoachSalaryStatement',
    params,
  );
}

/**
 * 教练薪资结算单-教练分页查询
 * @param {*} params
 * @returns
 */
export async function coachPageList(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/coachPageList',
    params,
  );
}

/**
 * 教练薪资结算单-删除教练
 * @param {*} params
 * @returns
 */
export async function deleteCoach(params) {
  return $x.post('/coach/admin/v2/coach/salary/statement/deleteCoach', params);
}

/**
 * 教练薪资结算单-添加教练
 * @param {*} params
 * @returns
 */
export async function addCoach(params) {
  return $x.post('/coach/admin/v2/coach/salary/statement/addCoach', params);
}

/**
 * 教练薪资结算单-添加教练-教练分页查询
 * @param {*} params
 * @returns
 */
export async function addCoachPageList(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/addCoachPageList',
    params,
  );
}

/**
 * 教练薪资结算单-添加教练-教练分页查询
 * @param {*} params
 * @returns
 */
export async function getCoachList(params) {
  return $x.post('/coach/admin/coach/salary/statement/coachList', params);
}

/**
 * 获取国家代码
 * @param {*} params
 * @returns
 */
export async function listCountryCodeList(params) {
  return $x.post('/common/listCountryCodeList', params);
}

/**
 * 教练薪资结算单-教练列表-教练课时详情分页查询
 * @param {*} params
 * @returns
 */
export async function coachClassRoomDetailPageList(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/coachStatement',
    params,
  );
}
/**
 * 结算单列表>课时详情-手动标记
 * @param {*} params
 * @returns
 */
export async function coachClassUserMark(params) {
  return $x.post('/coach/admin/v2/mark', params);
}

/**
 * 导出结算
 * @param {*} params
 * @returns
 */
export async function coachDataExport(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/detail/export',
    params,
  );
}

/**
 * 导出结算列表
 * @param {*} params
 * @returns
 */
export async function coachDataExportList(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/detail/export/tasks',
    params,
  );
}

/**
 * 结算数据
 * @param {*} params
 * @returns
 */
export async function settlementData(params) {
  return $x.post('/coach/admin/v2/settlementData', params);
}
/**
 * 结算单列表&gt;教练结算单&gt;用户上课明细
 * @param {*} params
 * @returns
 */
export async function settlementUserDetail(params) {
  return $x.post('/coach/admin/v2/settlementUserDetail', params);
}
/**
 * 结算单列表&gt;教练结算单&gt;删除用户
 * @param {*} params
 * @returns
 */
export async function deleteSettlementUser(params) {
  return $x.post('/coach/admin/v2/deleteSettlementUser', params);
}
/**
 * 结算单列表&gt;教练结算单&gt;同步薪资结算单
 * @param {*} params
 * @returns
 */
export async function syncStatement(params) {
  return $x.post('/coach/admin/v2/syncStatement', params);
}
/**
 * 导出
 * @param {*} params
 * @returns
 */
export async function coachSettlementData(params) {
  return $x.post('/coach/admin/v2/coachSettlementData', params);
}

/**
 * 手动标记结算
 * @param {*} params
 * @returns
 */
export async function manualMarkSettlement(params) {
  return $x.post('/coach/statement/settle/rights/manual', params);
}

/**
 * 根据手机号查询userId
 * @param {*} params
 * @returns
 */
export async function getUserIdByPhone(params) {
  return $x.post('/tenant/user/getUserId', params);
}

/**
 * 查询结算类型枚举
 * @param {*} params
 * @returns
 */
export async function getSettlementTypes(params) {
  return $x.post('/coach/statement/settle/types', params);
}

/**
 * 添加用户
 * @param {*} params
 * @returns
 */
export async function addSettlementUser(params) {
  return $x.post('/coach/admin/v2/addSettlementUser', params);
}
/**
 * 教练薪资结算单-商家分页查询
 * @param {*} params
 * @returns
 */
export async function getMerchantList(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/tenantPageList',
    params,
  );
}

/**
 * 教练薪资结算单-删除商家
 * @param {*} params
 * @returns
 */
export async function deleteTenant(params) {
  return $x.post('/coach/admin/v2/coach/salary/statement/deleteTenant', params);
}
/**
 * 教练薪资结算单-教练列表-教练结算分析
 * @param {*} params
 * @returns
 */
export async function coachStatementAnalysis(params) {
  return $x.post(
    '/coach/admin/v2/coach/salary/statement/coachStatement/analysis',
    params,
  );
}

/**
 * 商家结算收入分页查询
 * @param {*} params
 * @returns
 */
export async function getMerchantSettlementIncomePage(params) {
  return $x.post('/coach/statement/page', params);
}
/**
 * 导出
 * @param {*} params
 * @returns
 */
export async function exportSettlmentData(params) {
  return $x.post('/coach/statement/expenditure/export', params);
}

/**
 * 预算导出
 * @param {*} params
 * @returns
 */
export async function exportBudgetData(params) {
  return $x.post('/coach/statement/export/not_settlement', params);
}

/**
 * 薪资结算--结算发放记录
 * @param {*} params
 * @returns
 */
export async function salaryRecordsList(params) {
  return $x.post('/settlement/record/list', params);
}

/**
 * 薪资结算--结算发放记录生效状态开启/关闭
 * @param {*} params
 * @returns
 */
export async function salaryRecordsOnOff(params) {
  return $x.post('/settlement/record/onOff', params);
}
/**
 * 薪资结算--删除
 * @param {*} params
 * @returns
 */
export async function salaryRecordsDel(params) {
  return $x.post('/settlement/record/del', params);
}
/**
 * 薪资结算--导入
 * @param {*} params
 * @returns
 */
export async function salaryRecordsImport(params) {
  return $x.post('/settlement/record/import', params);
}
/**
 * 薪资结算--结算明细
 * @param {*} params
 * @returns
 */
export async function salaryRecordsDetails(params) {
  return $x.post('/settlement/details', params);
}

/**
 * 用户上课明细-&gt;打卡记录
 * @param {*} params
 * @returns
 */
export async function salaryDkRecord(params) {
  return $x.post('coach/admin/dkRecord', params);
}
/**
 * 批量导入
 * @param {*} params
 * @returns
 */
export async function addSettlementUserFile(params) {
  return $x.post('coach/admin/v2/addSettlementUserFile', params);
}

/**
 * 提现明细分页查询
 * @param {*} params
 * @returns
 */
export async function getExpenditureDetailPage(params) {
  return $x.post('/coach/statement/page/expenditure', params);
}

/**
 * 收入明细分页查询（修正接口地址）
 * @param {*} params
 * @returns
 */
export async function getWithdrawalDetailPage(params) {
  // 修正为正确的接口地址
  return $x.post('/coach/statement/page/income', params);
}

// 商家员工结算列表
export async function getEmployeeSettlementPage(params) {
  return $x.post('/employee/settlement/page', params);
}

/**
 * 商家在途明细
 * @param {*} params
 * @returns
 */
export async function getCashInTransitDetail(params) {
  // 修正为正确的接口地址
  return $x.post('/coach/statement/page/rights', params);
}

/**
 * 手动标记结算
 * @param {*} params
 * @returns
 */
export async function manualMarking(params) {
  return $x.post('/coach/statement/settle/rights/manual', params);
}

/**
 * 入账审核
 * @param {*} params
 * @returns
 */
export async function incomeAudit(params) {
  return $x.post('/coach/statement/settle/income/audit', params);
}

/**
 * 提现审核
 * @param {*} params
 * @returns
 */
export async function expenditureAudit(params) {
  return $x.post('/coach/statement/settle/expenditure/audit', params);
}

/**
 * 在途资金手动标记记录
 * @param {*} params
 * @returns
 */
export async function manualRecord(params) {
  return $x.post('/coach/statement/settle/rights/manual/record', params);
}

/**
 * 提现审核信息
 * @param {*} params
 * @returns
 */
export async function getAuditInfo(params) {
  return $x.post('/coach/statement/settle/expenditure/audit_info', params);
}

/**
 * 手动入账
 * @param {*} params
 * @returns
 */
export async function incomeManual(params) {
  return $x.post('/coach/statement/settle/income/manual', params);
}

/**
 * 手动入账-结算订单信息
 * @param {*} params
 * @returns
 */
export async function getOrderInfo(params) {
  return $x.post('/coach/statement/settle/manual/order/info', params);
}

/**
 * 手动入账-商家员工结算单详情
 * @param {*} params
 * @returns
 */
export async function getEmployeeSettlementDetail(params) {
  return $x.post('/employee/settlement/detail', params);
}
